import React from 'react'
import styled from 'styled-components'
import MiscHeading from '@pc/components/Works/Panel/shared/heading/MiscHeading'
import FeatureBox from './FeatureBox'
import SelectBoxes from '@pc/components/Works/Panel/shared/selectbox/SelectBoxes'
import EmphasisSelectBox from '@pc/components/Works/Panel/shared/selectbox/EmphasisSelectBox'
import SelectOption from '@pc/components/Works/Panel/shared/selectbox/SelectOption'
import ControlGroup from '@pc/components/Works/Panel/shared/ControlGroup'
import CheckBoxGroup from '@pc/components/Works/Panel/shared/checkbox/CheckBoxGroup'
import CheckBoxInput from '@pc/components/Works/Panel/shared/checkbox/CheckBoxInput'
import CheckBoxLabel from '@pc/components/Works/Panel/shared/checkbox/CheckBoxLabel'
import CheckBoxFeatureInputSet from './CheckBoxFeatureInputSet'
import type { SearchParamsAttributes, TimeSlot } from '@pc/components/Works/Panel/type'

interface PropsType {
  timeSlots: TimeSlot[]
  selectedKeepUpDay: SearchParamsAttributes['keepup_day']
  selectedKeepUpHour: SearchParamsAttributes['keepup_hour']
  selectedTimeSlotIds: SearchParamsAttributes['time_slots']
  changeState: (arg: any) => void
}

const DateTimeSelectBoxes = styled(SelectBoxes)`
  margin-top: 10px;
`

const renderHourOptions = () => {
  const range = Array.from({ length: 6 }, (_, i) => i + 3)
  return range.map((hour) => {
    return (
      <SelectOption key={hour} value={hour}>
        {hour}時間
      </SelectOption>
    )
  })
}

const renderDayOptions = () => {
  const range = Array.from({ length: 5 }, (_, i) => i + 1)
  return range.map((day) => {
    return (
      <SelectOption key={day} value={day}>
        週{day}日からOK
      </SelectOption>
    )
  })
}

const renderTimeSlotCheckboxes = (
  timeSlots: TimeSlot[],
  selectedTimeSlotIds: SearchParamsAttributes['time_slots'],
  toggleCheckbox: (e: React.ChangeEvent<HTMLInputElement>) => void
) => {
  return timeSlots.map((timeSlot) => {
    const { id, attributes } = timeSlot
    const timeSlotsId = `timeSlots-${id}`
    return (
      <CheckBoxFeatureInputSet key={id}>
        <CheckBoxInput type="checkbox" id={timeSlotsId} value={id} onChange={toggleCheckbox} checked={selectedTimeSlotIds?.includes(id)} />
        <CheckBoxLabel htmlFor={timeSlotsId}>{attributes.name}</CheckBoxLabel>
      </CheckBoxFeatureInputSet>
    )
  })
}

const DateTimeBox = (props: PropsType) => {
  const { timeSlots, selectedTimeSlotIds, selectedKeepUpDay, selectedKeepUpHour, changeState } = props

  const changeSelectBoxOfKeepUpDay = (e: React.ChangeEvent<HTMLInputElement>) => {
    changeState({ selectedKeepUpDay: e.target.value })
  }

  const changeSelectBoxOfKeepUpHour = (e: React.ChangeEvent<HTMLInputElement>) => {
    changeState({ selectedKeepUpHour: e.target.value })
  }

  const toggleCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target

    if (checked) {
      const concatedTimeSlotIds = selectedTimeSlotIds?.concat(value)
      changeState({ selectedTimeSlotIds: concatedTimeSlotIds })
    } else {
      const filteredTimeSlotIds = selectedTimeSlotIds?.filter((selectedTimeSlotId) => selectedTimeSlotId !== value)
      changeState({ selectedTimeSlotIds: filteredTimeSlotIds })
    }
  }

  return (
    <FeatureBox>
      <MiscHeading>働く日数・時間</MiscHeading>
      <DateTimeSelectBoxes>
        <EmphasisSelectBox value={selectedKeepUpDay} onChange={changeSelectBoxOfKeepUpDay}>
          <SelectOption value="" key={0}>
            週の勤務日数
          </SelectOption>
          {renderDayOptions()}
        </EmphasisSelectBox>
        <EmphasisSelectBox value={selectedKeepUpHour} onChange={changeSelectBoxOfKeepUpHour}>
          <SelectOption value="" key={0}>
            1日の勤務時間
          </SelectOption>
          {renderHourOptions()}
        </EmphasisSelectBox>
      </DateTimeSelectBoxes>
      <ControlGroup>
        <CheckBoxGroup>{renderTimeSlotCheckboxes(timeSlots, selectedTimeSlotIds, toggleCheckbox)}</CheckBoxGroup>
      </ControlGroup>
    </FeatureBox>
  )
}

export default DateTimeBox
